<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="是否显示班级评价" prop="isClassEvaluate"  label-width="150px">
        <el-radio-group v-model="dataForm.isClassEvaluate" >
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否显示争章集赞" prop="isZzjz"  label-width="150px">
        <el-radio-group v-model="dataForm.isZzjz">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否显示红领巾争章" prop="isHljzz"  label-width="150px">
        <el-radio-group v-model="dataForm.isHljzz">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>      </el-form-item>
      <el-form-item label="是否显示点赞曝光" prop="isExposure"  label-width="150px">
        <el-radio-group v-model="dataForm.isExposure">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>      </el-form-item>
      <el-form-item label="是否显示数据统计" prop="isDataStatistics"  label-width="150px">
        <el-radio-group v-model="dataForm.isDataStatistics">
          <el-radio :label="0" >否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        isClassEvaluate: '',
        isZzjz: '',
        isHljzz: '',
        isExposure: '',
        isDataStatistics: '',
        schoolId: '',
        creator: '',
        updater: '',
        createDate: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/moralismScreenRule/moralismscreenrule/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/moralismScreenRule/moralismscreenrule/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  }
}
</script>
